import { EVMAddress } from '@src/types/token'

export const MIN_MILES_FOR_REFERRAL_CODE = 10_000
export const MIN_MILES_FOR_MON_PURCHASE = 1000
export const MONAD_TESTNET_WMON_ADDRESS = '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701'.toLowerCase() as EVMAddress
